import script from "./SectionHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHero.vue?vue&type=script&setup=true&lang=ts"

import "./SectionHero.vue?vue&type=style&index=0&id=329e2280&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329e2280"]])

export default __exports__